import type { UIStringsOverride } from "../i18n-ui.ts";

/** Bulgarian (bg) UI strings. */
export const bg: UIStringsOverride = {
  actions: {
    addToCursor: "Добави в Cursor",
    addToVscode: "Добави във VS Code",
    askAI: "Попитай ИИ за тази страница",
    connectMcp: "Свържи се с MCP",
    copied: "Копирано!",
    copyClaudeCode: "Копирай командата на Claude Code",
    copyCode: "Копирай кода",
    copyCodex: "Копирай командата на Codex",
    copyMarkdown: "Копирай като Markdown",
    copyServerUrl: "Копирай URL на сървъра",
    edit: "Редактирай в GitHub",
    export: "Експортирай",
    exportEpub: "Експортирай в EPUB",
    exportPdf: "Експортирай в PDF",
    generating: "Генериране…",
    openIn: "Отвори в {name}",
    openInChat: "Отвори в чата",
    scrollToTop: "Нагоре",
  },
  ask: {
    ai: "ИИ",
    clear: "Изчисти разговора",
    close: "Затвори",
    copy: "Копирай разговора",
    empty: "Задайте въпрос за документацията.",
    error: "Съжаляваме, нещо се обърка.",
    label: "Задайте въпрос",
    placeholder: "Задайте въпрос…",
    send: "Изпрати",
    tip: "Съвет: Можете да отваряте и затваряте чата с",
    title: "Попитай ИИ",
    you: "Вие",
  },
  banner: { dismiss: "Затваряне на съобщението" },
  changelog: {
    description: "Актуализации на продукта и бележки към изданията.",
    showReleases: "Покажи изданията на {version}",
    title: "Дневник на промените",
  },
  content: { diagramError: "Тази диаграма не можа да бъде показана." },
  feedback: {
    no: "Не",
    question: "Беше ли полезна тази страница?",
    thanks: "Благодарим за обратната връзка!",
    yes: "Да",
  },
  languageSwitcher: { label: "Език", untranslated: "Непреведено" },
  nav: {
    back: "Назад",
    breadcrumb: "Навигационна пътека",
    closeNavigation: "Затвори навигацията",
    deprecated: "остаряло",
    featured: "Препоръчано",
    githubRepository: "Хранилище в GitHub",
    navigation: "Навигация",
    primary: "Основно",
    sections: "Раздели",
    toggleNavigation: "Превключи навигацията",
    toggleTheme: "Превключи цветовата тема",
  },
  notFound: {
    description: "Не успяхме да намерим страницата, която търсите.",
    home: "Обратно към началната страница",
    title: "Страницата не е намерена",
  },
  page: {
    lastUpdated: "Последна актуализация",
    next: "Напред",
    pagination: "Пагинация",
    previous: "Назад",
    skipToContent: "Към съдържанието",
  },
  search: {
    all: "Всички",
    allLanguages: "Всички езици",
    askAi: "Попитай ИИ",
    askAiHint: "Получете незабавен отговор от ИИ",
    button: "Търсене",
    devOnly: "Търсенето е достъпно в производствената компилация.",
    error: "Нещо се обърка. Моля, опитайте отново.",
    label: "Търсене в документацията",
    navigate: "навигация",
    noResults: "Няма намерени резултати.",
    open: "отвори",
    placeholder: "Търсене в документацията…",
    popular: "Популярни",
    preview: "преглед",
    results: "Резултати",
  },
  toc: { title: "На тази страница" },
};
